import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Pagination from '@/components/pagination';
import { payrollSubStaffList, payrollSubStaffDelete, payrollSubStaffAdd, syncStaffItem } from '@/api/payroll';
import searchPopup from '../../compontents/search-popup.vue';
import organization from '@/components/organization';
import staffUpload from './components/upload-dialog.vue';
import staffDetail from '../../compontents/detail';
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: {
    searchPopup: searchPopup,
    Pagination: Pagination,
    organization: organization,
    staffUpload: staffUpload,
    staffDetail: staffDetail
  },
  data: function data() {
    return {
      form: {
        department_list: [],
        staff_list: [],
        sub_project_id: this.$route.params.id,
        data_type: 'all',
        search_word: '',
        page_size: 20,
        page: 1
      },
      page: {
        pageSizes: [20, 50, 100],
        total: 0
      },
      subProjectInfo: {},
      subStaffList: [],
      multipleSelection: [],
      // 表格选中数据
      orgVisible: false,
      updateLoa: false,
      deleteLoa: false,
      staffId: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return 500;
    }
  }),
  watch: {
    subStaffList: {
      handler: function handler(val) {
        this.$emit('changeList', val);
      },
      deep: true,
      immediate: true
    }
  },
  created: function created() {
    this.loadSubStaffList(); // 获取员工列表
  },

  methods: {
    loadSubStaffList: function loadSubStaffList() {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : _this.form;
              _context.next = 3;
              return payrollSubStaffList(_objectSpread(_objectSpread({}, params), {}, {
                sort: _this.sort,
                // 排序相关
                dir: _this.dir
              }));
            case 3:
              res = _context.sent;
              if (res && res.code === 1) {
                _this.page.total = res.data.count;
                _this.$set(_this.activeData, 'subStaffList', res.data.list);
                _this.subStaffList = res.data.list;
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      // 每页共多少条数据
      this.form.page = 1;
      this.form.page_size = val;
      this.loadSubStaffList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      // 当前页数据
      this.form.page = val;
      this.loadSubStaffList();
      this.$refs.multipleTable.clearSelection();
    },
    handleSearch: function handleSearch() {
      // 筛选
      this.$refs.searchPopup.init();
    },
    getSearchData: function getSearchData(data) {
      // 信息筛选
      var department_id = data.department_id;
      data.department_name = department_id.map(function (item) {
        return item.department_name;
      }).join(',');
      this.form.page = 1;
      this.loadSubStaffList(_objectSpread(_objectSpread({}, this.form), data));
    },
    batchDelete: function batchDelete(row) {
      var _this2 = this;
      // 批量删除
      this.$confirm(this.$t('payroll_wage_24', {
        x: row ? 1 : this.multipleSelection.length
      }), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        _this2.deleteLoa = true;
        var staff_info_id = row ? [row.staff_info_id] : _this2.multipleSelection.map(function (item) {
          return item.staff_info_id;
        });
        payrollSubStaffDelete({
          staff_ids: staff_info_id.join(','),
          sub_project_id: _this2.form.sub_project_id
        }).then(function (res) {
          _this2.deleteLoa = false;
          var code = res.code;
          if (code === 1) {
            _this2.$refs.multipleTable.clearSelection();
            _this2.loadSubStaffList();
          }
        });
      }).catch(function () {});
    },
    updateData: function updateData() {
      var _this3 = this;
      // 更新数据
      this.$confirm(this.$t('payroll_wage_25'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        _this3.$emit('disabled', true);
        _this3.updateLoa = true;
        syncStaffItem({
          sub_project_id: _this3.form.sub_project_id
        }).then(function (res) {
          if (res && res.code === 1) {
            // 数据更新成功 提示
            var str = '<div>';
            if (res.data.update_count) str += "<p>".concat(_this3.$t('payroll_salary_35', {
              x: res.data.update_count
            }), "</p>");
            if (res.data.delete_count) str += "<p>".concat(_this3.$t('payroll_salary_36', {
              x: res.data.delete_count
            }), "</p>");
            if (!res.data.update_count && !res.data.delete_count) str = _this3.$t('payroll_wage_26');
            str += '</div>';
            _this3.$message({
              dangerouslyUseHTMLString: true,
              type: res.data.delete_count ? 'warning' : 'success',
              message: str
            });
            _this3.loadSubStaffList();
          }
          _this3.updateLoa = false;
        }).finally(function () {
          return _this3.$emit('disabled', false);
        });
      });
    },
    batchAddStaff: function batchAddStaff() {
      // 批量添加成员
      this.$refs.staffUpload.init();
    },
    getUploadData: function getUploadData() {
      // 批量导入
      this.form.page = 1;
      this.$refs.multipleTable.clearSelection();
      this.loadSubStaffList();
    },
    addStaff: function addStaff() {
      // 添加成员
      this.orgVisible = true;
      this.form.department_list = [];
      this.form.staff_list = [];
    },
    getSelectNode: function getSelectNode(data) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var staff_ids, department_ids, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!data.staff_list.length && !data.dept_list.length)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", false);
            case 2:
              staff_ids = data.staff_list.map(function (item) {
                return item.staff_id;
              }).join(',');
              department_ids = data.dept_list.map(function (item) {
                return item.department_id;
              }).join(',');
              _this4.form.department_list = data.dept_list;
              _this4.form.staff_list = data.staff_list;
              _context2.next = 8;
              return payrollSubStaffAdd({
                staff_ids: staff_ids,
                department_ids: department_ids,
                sub_project_id: _this4.form.sub_project_id
              });
            case 8:
              res = _context2.sent;
              if (res && res.code === 1) {
                _this4.form.page = 1;
                _this4.$refs.multipleTable.clearSelection();
                _this4.loadSubStaffList();
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      // 表格选中
      this.multipleSelection = val;
    },
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.sort = prop;
      this.dir = order;
      this.loadSubStaffList();
    },
    handleCheck: function handleCheck(item) {
      // 查看
      this.staffId = item.staff_info_id;
      this.$refs.staffDetail.init();
    }
  }
};